
import ArrowLeft3 from "../../../assets/duotone/ArrowLeft3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowLeft3Icon({ className, dataTestid = "ArrowLeft3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowLeft3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
